import { FC, useContext, useEffect } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import Card from '../Card/Card';
import common from '../../util/scss/common.module.scss';
import styles from './MigrateStaffAccountSuccess.module.scss';
import CoBranding from '../CoBranding/CoBranding';
import MigrateStaffAccountContext, { EMigrateStaffAccountUiState } from '../../contexts/MigrateStaffAccountContext';
import { replacePhrase } from '../../util/helpers';
import { delayLoginMilliseconds } from '../../util/constants';
import { useHasChanged } from '../../util/customHooks';
import { LoadingButton } from '@mui/lab';

const MigrateStaffAccountSuccess: FC = () => {
    const { language, coBranding, csrfToken, getCsrfToken } = useContext(GlobalContext);
    const { migrateStaffAccountUiState, setMigrateStaffAccountUiState, email, login } =
        useContext(MigrateStaffAccountContext);
    const loginIsInitialized = useHasChanged(csrfToken);
    const formattedDesc = replacePhrase(language.staffAccountMigration.success.desc, '<email>', email);

    const handleInitializeLogin = async () => {
        setMigrateStaffAccountUiState(EMigrateStaffAccountUiState.loading);
        await getCsrfToken();
    };

    useEffect(() => {
        if (loginIsInitialized) {
            // delay login to allow Identity.LegacyUpdates service time to resolve
            setTimeout(() => {
                login();
            }, delayLoginMilliseconds);
        }
    }, [loginIsInitialized]);

    return (
        <Card>
            {(coBranding.logoUrl || coBranding.name) && (
                <CoBranding logoUrl={coBranding.logoUrl} name={coBranding.name} />
            )}
            <header>
                <h1 className={`${common.pageHeader} ${common.withSubhead}`}>
                    {language.staffAccountMigration.success.title}
                </h1>
                <div className={`${common.pageSubhead} ${styles.desc}`}>
                    <p>{formattedDesc}</p>
                    <p>{language.staffAccountMigration.success.desc2}</p>
                </div>
            </header>
            <section className={styles.cta}>
                <LoadingButton
                    variant="contained"
                    type="button"
                    onClick={handleInitializeLogin}
                    className={common.buttonShim}
                    loading={migrateStaffAccountUiState === EMigrateStaffAccountUiState.loading}
                    disabled={migrateStaffAccountUiState === EMigrateStaffAccountUiState.loading}
                >
                    {language.staffAccountMigration.success.cta}
                </LoadingButton>
            </section>
        </Card>
    );
};

export default MigrateStaffAccountSuccess;
